import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import useSelector from 'hooks/useSelector';
import { IRouteConfig, RouteList } from "helpers/route-config";
import { SignedInState } from "shared/store/applicationState"
import { signinRedirect } from 'shared/services/userService';
import { userHasPermission } from 'hooks/useRoles';
import Loading from "pages/Loading";
import NoAccess from "pages/NoAccess";
import AccessRequired from "pages/AccessRequired";


export const ProtectedRoute = (props: IRouteConfig) => {
    const user = useSelector(state => state.user);
    console.log('Protect Route');
    return user
        ? (<Routes><Route {...props} element={props.element} /></Routes>)
        : (<Navigate to={'/login'} />);
}


export const AppRoutes = () => {
    const user = useSelector(state => state.user);
    const signedInState = useSelector(state => state.signedInState);

    return (
        <React.Fragment>
            {
                RouteList.map((route, i) => {

                    const getRouteComponent = (): any => {

                        if (signedInState === undefined || signedInState === SignedInState.Loading) {
                            return Loading;
                        }

                        if (user === undefined) {
                            return signinRedirect;
                        }

                        return route.element;
                    }

                    const component = getRouteComponent();

                    const accessRequired = user !== undefined && (user.roles === undefined || user.roles.length < 1);
                    const hasPermissionRouteProtected = userHasPermission(route.permission) && !route.unProtected;
                    const hasPermissionRouteUnprotected = userHasPermission(route.permission) && route.unProtected;

                    if (accessRequired) {
                        return (<Routes><Route key={i} {...route} element={<AccessRequired />} /></Routes>);
                    }

                    if (hasPermissionRouteProtected) {
                        return (<Routes><Route key={i} {...route} element={component} /></Routes>);
                    }

                    else if (hasPermissionRouteUnprotected) {
                        return (<Routes><Route key={i} {...route} /></Routes>);
                    }

                    else {
                        return (<Routes><Route key={i} {...route} element={<NoAccess />} /></Routes>);
                    }
                })
            }

        </React.Fragment>
    );
};
